/**
 * SubmitRequest Page
 *
 * Page wrapper for the Submit Request Form.
 *
 * @module pages/feedback/SubmitRequest
 */

import React from 'react';
import { Box, Container } from '@mui/material';
import SubmitRequestForm from '../../components/feedback/SubmitRequestForm';

/**
 * SubmitRequest Page
 */
const SubmitRequest: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box py={4}>
        <SubmitRequestForm />
      </Box>
    </Container>
  );
};

export default SubmitRequest;
